import { t } from 'i18next';

import { UomConversionStatus } from 'companySettings/enums';

// Inclusive span limit, mirroring MAX_RANGE_DAYS in the BE validation. Enforced
// twice on purpose: the pickers clamp interactive selection, the schema catches
// typed-in dates (min/maxDate only gray the calendar, they don't block typing).
export const MAX_RANGE_DAYS = 366;

export const getUomConversionStatusLabels = (): Record<UomConversionStatus, string> => ({
  [UomConversionStatus.EXISTS]: t('labelExists'),
  [UomConversionStatus.MISSING]: t('labelMissing'),
  [UomConversionStatus.NO_BASE_UOM]: t('labelNoBaseUom'),
  [UomConversionStatus.NO_CORPORATE_PART]: t('labelNoCorporatePart'),
  [UomConversionStatus.NO_EXTRACTED_UOM]: t('labelNoExtractedUom'),
  [UomConversionStatus.SAME_AS_BASE]: t('labelSameAsBase'),
});
